import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { NavMenu } from '../interfaces/nav-menu';
import * as NavMenuActions from './nav-menu.actions';

export const NavMenuFeatureKey = 'navMenu';

export interface State extends EntityState<NavMenu> {
  loading: boolean;
  loaded: boolean;
  error: any;

}

export const adapter: EntityAdapter<NavMenu> = createEntityAdapter<NavMenu>({});

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null
});

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();

const _navMenuReducer = createReducer(
  initialState,
  /*** Load all */
  on(NavMenuActions.loadNavMenus, state => {
    return { ...state, ...{ loading: true, loaded: false } };
  }),
  on(NavMenuActions.loadNavMenusSuccess, (state, action) => {
    return adapter.setAll(action.data, { ...state, ...{ loading: false, loaded: true, error: null } });
  }),
  on(NavMenuActions.loadNavMenusFailure, (state, action) => ({ ...state, ...{ loading: false, loaded: true, error: action.error } })),

  on(NavMenuActions.clearNavMenuSaveOk, state => ({
    ...state,
    ...{ savedOk: false }
  })),
);

export function navMenuReducer(state: State | undefined, action: Action) {
  return _navMenuReducer(state, action);
}
